export default __webpack_public_path__ + "static/tanecni-kurzy-2-d5867845aa468a6752b2eddecc930414.jpg";